import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { FunnelData } from "../lib/api";

interface Props {
  data: FunnelData;
}

// Reihenfolge = Reihenfolge im Flow. Die letzten drei Stufen liegen bei
// Shopify, nicht bei uns — sie stehen hier, weil der Trichter sonst vor der
// einzigen Stufe endet, auf die es geschäftlich ankommt.
const STEPS: { key: keyof FunnelData; label: string }[] = [
  { key: "personalization_started", label: "Overlay geöffnet" },
  { key: "photo_uploaded", label: "Foto durch" },
  { key: "preview_generated", label: "Character sichtbar" },
  { key: "character_rated", label: "Bewertet 👍/👎" },
  { key: "cover_step_viewed", label: "Cover-Schritt" },
  { key: "cover_selected", label: "Cover gewählt" },
  { key: "extras_step_viewed", label: "Extras-Schritt" },
  { key: "customization_changed", label: "Extra geändert" },
  { key: "order_review_viewed", label: "Übersicht" },
  { key: "add_to_cart", label: "In den Warenkorb" },
  { key: "begin_checkout", label: "Checkout gestartet" },
  { key: "purchase", label: "Gekauft" },
];

export default function FunnelChart({ data }: Props) {
  const top = Number(data.personalization_started) || 1;
  const rows = STEPS.map((s) => ({
    step: s.label,
    sessions: Number(data[s.key] ?? 0),
    rate:
      ((Number(data[s.key] ?? 0) / top) * 100).toFixed(1).replace(".", ",") +
      " %",
  }));

  return (
    <ResponsiveContainer width="100%" height={440}>
      <BarChart
        data={rows}
        layout="vertical"
        margin={{ top: 4, right: 64, bottom: 4, left: 8 }}
      >
        <CartesianGrid
          strokeDasharray="3 3"
          stroke="var(--border)"
          horizontal={false}
        />
        <XAxis
          type="number"
          allowDecimals={false}
          fontSize={11}
          stroke="var(--muted-foreground)"
          tickLine={false}
        />
        <YAxis
          dataKey="step"
          type="category"
          width={140}
          fontSize={12}
          stroke="var(--muted-foreground)"
          tickLine={false}
          axisLine={false}
        />
        <Tooltip
          formatter={(v: number, _n, p) => [
            `${v} (${p.payload.rate})`,
            "Sessions",
          ]}
          contentStyle={{
            borderRadius: 8,
            border: "1px solid var(--border)",
            fontSize: 12,
          }}
        />
        <Bar dataKey="sessions" fill="var(--chart-1)" radius={[0, 4, 4, 0]}>
          <LabelList
            dataKey="rate"
            position="right"
            fontSize={11}
            fill="var(--muted-foreground)"
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
